import React from "react";

export const Alerts = () => <div>Alerts</div>;
